import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { PageTitle } from '@plato/app-shared/components/page-title';
import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useUserOverviewColumns } from '../features/team/columns/use-user-overview-columns.tsx';
import { TeamPage } from '../features/team/components/team-page.tsx';

export function useTeamAiMeta(): AppRegistryPage {
    const { t } = useTranslation();
    return usePageAiMeta(
        {
            path: '/team',
            title: t('page_title', { ns: 'team' }),
            requires: ['canViewTeamPage'],
            managerOnly: true,
            description:
                "The manager's view of the team: one row per rep with their {{metric}} and the other " +
                'listed figures, open risks and opportunities, processed AI recommendations, coverage, ' +
                'logged interactions and open tasks, plus team totals as stat cards. Filter by period, ' +
                'user, role and sales region. Only managers in Manager view can open it. Send the user ' +
                'here for how a rep or the team is doing, not for one customer.',
        },
        useUserOverviewColumns(),
    );
}

function Team(): React.JSX.Element {
    const { t } = useTranslation('team');

    return (
        <>
            <PageTitle title={t('page_title')} />
            <TeamPage />
        </>
    );
}

export default Team;
